import { render, staticRenderFns } from "./restrictedSaleFailureData.vue?vue&type=template&id=63614afb&scoped=true&"
import script from "./restrictedSaleFailureData.vue?vue&type=script&lang=js&"
export * from "./restrictedSaleFailureData.vue?vue&type=script&lang=js&"
import style0 from "./restrictedSaleFailureData.vue?vue&type=style&index=0&id=63614afb&prod&lang=stylus&scoped=true&"
import style1 from "./restrictedSaleFailureData.vue?vue&type=style&index=1&id=63614afb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63614afb",
  null
  
)

export default component.exports